import React, { FC } from 'react';
import './cohort.scss';

const Cohort = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
  <div className='page cohort'>
    <div className='title'> BACKGROUND + FOUNDATIONS </div>
    <div className='section'>
      <div className='subtitle'>PURPOSE</div>
      <div className='content'>
      To cultivate an intentional community of creators that encourages growth, collaboration, and creative development—whether you’re a full-time entrepreneur, weekend hobbyist, or somewhere in between. This cohort centers sustainable creative practice, rest, and community care as foundational values, recognizing that our creativity flourishes when we’re supported not just as artists, but as whole people.
      <div className='spacer'></div>
      Participation in the cohort is both a personal commitment to your own creative journey and a communal one—to show up for, encourage, and empower your fellow cohort members.
      </div>
    </div>
    <hr/>
    <div className='section'>
      <div className='subtitle'>VALUES</div>
      <div className='content'>
      We root this cohort in:
      <ul className='list'>
        <li><span className='bold pink'>Collaboration</span> – together we each hold a collaborative mindset rooted in communication, honesty, and grace for one another</li>
        <li><span className='bold pink'>Intentionality</span> – showing up with care, curiosity, and purpose in what we create and how we support each other</li>
        <li><span className='bold pink'>Rest</span> – rest is doing something. We prioritize practices that honor our time, energy, and capacity</li>
        <li><span className='bold pink'>Accessibility</span> – reducing barriers for ourselves and others, and embrace different ways of creating and participating</li>
      </ul>
      </div>
      <hr/>
      <div className='section'>
        <div className='subtitle'>WHO THIS IS FOR</div>
        <div className='content'>
          This cohort centers <span className='bold'>BIPOC, queer, and underrepresented creators.</span> We recognize the systemic barriers these communities face in creative and entrepreneurial spaces—and this cohort exists to create new paths forward through shared resources, mutual encouragement, and communal visibility.
        </div>
      </div>
      <hr/>
      <div className='section'>
        <div className='subtitle'>OUR GOALS</div>
        <div className='content'>
          <ul className='list'>
            <li>Build a supportive and values-aligned network of creators</li>
            <li>Reduce logistical and financial barriers to creative participation through the Ricecake Collective booth at the SJ Made Winterfest Market </li>
            <li>Create space to explore sustainable practices (emotional, physical, creative) </li>
            <li>Offer opportunities for learning, visibility, and collaboration</li>
            <li>Model a cohort framework that can be replicated for future seasons</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  );
}

export default Cohort;
